﻿import * as $ from 'jquery';
import { bind, canWrite, Binding } from 'common/dom/binding';
import { Observable } from 'common/barrels/rx';

// the reason the value set is wrapped in a setTimeout is that IE and Edge seem to struggle with null / selectedIndex=-1 operations
// before the select is added to the document, meaning it will wind up displaying the first element.

export function select(value: Binding<string>, options: JQuery[]) {
    const $select = $('<select />').append(options);

    if (!canWrite(value))
        $select.attr('disabled', 'disabled');

    const updateIfDifferent = x => {
        if ($select.val() !== x)
            window.setTimeout(() => $select.val(x));
    };

    const subscriptions = bind<string>(value, updateIfDifferent, () => Observable.fromEvent<any>($select, 'change').map(() => $select.val()));

    $select.owns(subscriptions);

    return $select;
}